import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getMachineById, selectInspectedMachine, clearInspectedMachine } from '@reducers/machines';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { Machine } from '@api/domain';
import { useFetch } from '@api/hooks';

interface UseGetMachineByIdParams {
  id: number | null;
}

export const useGetMachineById = ({ id }: UseGetMachineByIdParams) => {
  const dispatch = useAppDispatch();
  const machine = useSelector(selectInspectedMachine);

  const { loading, refetch } = useFetch<Machine>({
    fetchFn: async () => {
      if (!id) return null;
      const data = await dispatch(getMachineById(Number(id)));
      return data?.[0] || null;
    },
    deps: [id],
  });

  useEffect(() => () => {
    dispatch(clearInspectedMachine());
  }, []);

  return { machine, loading, refetch };
};
